import React, { useEffect } from 'react';

import { logout } from './authTokenUtils';

// Exports
type Props = { fallback?: React.ReactNode };
/** Rendering this component will immediately log the user out */
export const Logout = ({ fallback = null }: Props) => {
  useEffect(() => {
    (async () => {
      await logout();
    })();
  }, []);

  return <>{fallback}</>;
};
